import { getVisualizationSizeOfFileForBrowser } from 'gltf-optimizer-browser';
import { ModelSize3D } from '../types/product';
import { Units } from './enums';

export const getDimensionsFromUrl = async (modelUrl): Promise<ModelSize3D> => {
    let modelSize3D = {};
    try {
        const res = await fetch(modelUrl);
        const blob = await res.blob();
        const file = new File([blob], 'test.glb');
        if (file) {
            const arrayBuffer = await file.arrayBuffer();
            const sizes = await getVisualizationSizeOfFileForBrowser({ inputBuffer: new Uint8Array(arrayBuffer), debug: true });
            let size = [sizes.max[0] - sizes.min[0], sizes.max[1] - sizes.min[1], sizes.max[2] - sizes.min[2]];
            const maxDimension = Math.max(size[0], size[1], size[2]);
            let unit = Units.METER;
            if (maxDimension < 1.0) {
                size[0] *= 100;
                size[1] *= 100;
                size[2] *= 100;
                unit = Units.CENTIMETER;
            }

            modelSize3D = { width3D: parseFloat(size[0].toFixed(2)), depth3D: parseFloat(size[1].toFixed(2)), height3D: parseFloat(size[2].toFixed(2)), unit: unit };
        }
    } catch (error) {
        console.log(error);
    }
    return modelSize3D;
};
